// extracted by css-extract-rspack-plugin
export default {"buttons":"lcvtcSu9Vfc8gyU7"};